module.exports = __webpack_public_path__ + "images/iworkbay.jpg";